import PaneTemplate from '../../html/components/pane.html'
import PaneListTemplate from '../../html/components/pane-list.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

const panesList = Relation()

export const Pane = Component('v-pane', {
  mixins: [
    MemberOf(panesList, 'list')
  ],
  template: PaneTemplate,
  props: {
    name: {
      type: String,
      default: null
    },
    current: {
      type: Boolean,
      default: false
    },
    elementToFocus: {
      type: Element,
      default: null
    }
  },
  data () {
    return {
      active: this.current
    }
  },
  watch: {
    current () {
      this.active = this.current
    },

    active () {
      this.$emit('change', this.active)
    }
  },
  methods: {
    focus () {
      const elementToFocus = this.elementToFocus || this.$el
      elementToFocus.focus()
    }
  }
})

export const PaneList = Component('v-pane-list', {
  mixins: [
    HasMany(panesList, 'panes')
  ],
  template: PaneListTemplate,
  data () {
    return {
      stack: []
    }
  },
  computed: {
    current: {
      get () {
        return this.stack[0]
      },

      set (pane) {
        this.navigate(pane.name)
      }
    }
  },
  watch: {
    panes (panes) {
      panes.forEach(pane => {
        if (pane.current) {
          this.stack = [pane]
        }
      })
    }
  },
  methods: {
    navigate (name) {
      const pane = this.panes.find(pane => pane.name === name)

      if (!pane || pane === this.current) {
        return
      }

      this.stack[0].active = false
      this.stack = [pane, ...this.stack]
      pane.active = true
    },

    back () {
      if (this.stack.length <= 1) {
        return
      }

      const [first, ...rest] = this.stack

      first.active = false
      this.stack = rest
      this.stack[0].active = true
    }
  }
})
